import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet-async";
function Terms() {
  return (
    <>
    
<Helmet>
  <title>Terms & Conditions | Astro Logical Solutions</title>

  <meta
    name="description"
    content="Read the terms and conditions for using Astro Logical Solutions, including website usage, orders, payments and customer responsibilities."
  />

  <link
    rel="canonical"
    href="https://astrologicalsolutions.in/terms-and-conditions"
  />

  <meta
    name="robots"
    content="index, follow, max-image-preview:large"
  />

  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Terms & Conditions | Astro Logical Solutions"
  />
  <meta
    property="og:description"
    content="Review the terms and conditions for shopping and using services at Astro Logical Solutions."
  />
  <meta
    property="og:url"
    content="https://astrologicalsolutions.in/terms-and-conditions"
  />
  <meta
    property="og:site_name"
    content="Astro Logical Solutions"
  />
</Helmet>

      <Header />
      <div className="shipping-page">
        <section className="shipping-hero">
          <h1 className="page-title">
            Terms and Conditions - Astro <br /> Logical Solutions
            <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Heading decoration"
              />
            </div>
          </h1>
          <div className="hero-card">
            <span className="hero-badge">Legal · Astro Logical Solutions </span>
            <h2>Terms & Conditions</h2>
            <div className="hero-stars">
              <span>✦</span>
              <span>✦</span>
              <span>✦</span>
            </div>
            <p className="hero-description">
              These Terms and Conditions constitute the legally binding
              agreement between you and Astro Logical Solutions governing your
              use of https://astrologicalsolutions.in/ and any purchases made
              through our Website. Please read these Terms carefully. By
              accessing or using the Website or placing an order with us, you
              acknowledge that you have read, understood, and agreed to be bound
              by these Terms.
            </p>
            <div className="shipping-points">
              <span>Seller identity & contact disclosed</span>
              <span>Governed by the laws of India</span>
              <span>Belief-based · no medical claims</span>
              <span>Your statutory consumer rights preserved</span>
            </div>
          </div>
        </section>
        <div className="seller-grievance-box">
          <h3>
            Seller & Grievance Contact (Consumer Protection Act, 2019 &
            E-Commerce Rules, 2020)
          </h3>

          <p>
            <strong>Registered Office:</strong> Shiva Aangan, Bachan Singh
            Colony, Lane No.9, Muzaffarnagar, Uttar Pradesh, 251001
          </p>
          <p>
            <strong>Customer Support:</strong>{" "}
            <a href="mailto:support@astrologicalsolutions.in">
              support@astrologicalsolutions.in
            </a>{" "}
            · WhatsApp{" "}
            <a href="https://wa.me/7351739191" target="_blank" rel="noreferrer">
              +91 7351739191
            </a>{" "}
            · Mon–Sat, 10am–7pm IST
          </p>
        </div>
        <div className="seller-grievance-box">
          <p>
            <b>Important</b> — belief-based products and services, not medical
            treatment. Gemstones, Rudraksha, astrological remedies,
            consultations, and predictions offered by Astro Logical Solutions
            are based on traditional Vedic and astrological beliefs and are
            intended solely for personal guidance, faith, and self-reflection.
            These products and services are not medicines, drugs, or medical
            treatments and should not be considered a substitute for qualified
            medical, psychological, legal, or financial advice. Astro Logical
            Solutions does not claim to diagnose, treat, cure, or prevent any
            disease or medical condition and does not guarantee any particular
            result relating to health, wealth, relationships, marriage, career,
            business, or legal matters. Astrology is interpretive in nature, and
            experiences or results may differ from person to person. Customers
            are encouraged to use their own judgment and make informed decisions
            based on their individual circumstances.
          </p>
        </div>
        <section className="shipping-details">
          <div className="content-section">
            <div className="section-heading">
              <h3>1. Acceptance of These Terms</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              These Terms and Conditions constitute an electronic agreement
              between you and Astro Logical Solutions and govern your access to
              and use of the Website, as well as any purchases or services you
              obtain through it. By visiting or using the Website, creating an
              account, placing an order, or otherwise engaging with our
              services, you acknowledge that you have read, understood, and
              agreed to be bound by these Terms and Conditions, together with
              any additional terms, policies, or guidelines referenced in these
              Terms or made available on the Website.
              <br />
              These Terms apply to all users of the Website, including visitors,
              customers, vendors, merchants, and individuals who submit or
              contribute content.
              <br />
              All products, services, descriptions, and information displayed on
              the Website are provided as an invitation to make an offer and do
              not constitute a binding offer for sale. When you place an order,
              you are making an offer to purchase the selected product or
              service in accordance with these Terms and Conditions. Astro
              Logical Solutions reserves the right to accept, decline, modify,
              or cancel any order, in whole or in part, at its discretion,
              subject to applicable law.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>2. Eligibility & Age</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              The Website and its Services are available only to individuals who
              are legally capable of entering into a binding contract under the
              applicable laws of India and the country in which they reside.
              <br />
              The Services may not be used by minors or by any user whose access
              to the Website or Services has been temporarily or permanently
              suspended or restricted by Astro Logical Solutions.
              <br />
              By accessing or using the Website, you represent and warrant that
              you have the legal right, authority, and capacity to enter into
              this Agreement and to comply with all of its terms and conditions.
              If you do not meet these requirements, you must not access or use
              the Website or its Services.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>3. Your Account & User Obligations</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              You are responsible for ensuring that all information and details
              provided to Astro Logical Solutions are accurate, complete, and up
              to date. You are also responsible for all activities carried out
              through your account. Your account is intended solely for your
              personal use and may not be assigned, transferred, sold, licensed,
              shared, or otherwise made available to any other individual or
              entity. You may not permit or authorize another person to access
              or use your account on your behalf.
            </p>

            <div className="shipping-info-cards">
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>Accurate information</h4>
                <p>
                  Provide current, complete and accurate purchase and account
                  information (including email and payment details), and update
                  it promptly so we can complete your transactions and contact
                  you.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Payment details you own</h4>

                <p>
                  You must use only valid debit/credit cards or bank accounts
                  that you lawfully own or are authorised to use, with
                  sufficient funds/credit to cover the payment and any
                  applicable fees.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Payment authorisation</h4>

                <p>
                  By providing your payment details and initiating a
                  transaction, you authorise the Company to process it, subject
                  to the terms of this Agreement.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Lawful, honest use</h4>

                <p>
                  You will not post or transmit defamatory, inaccurate, abusive,
                  obscene, offensive, threatening, harassing or illegal
                  material, or any content that infringes another party's
                  rights.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>No false information</h4>

                <p>
                  You will not provide inaccurate, misleading or false
                  information; if information you have given becomes inaccurate,
                  you will promptly notify us.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Verification</h4>

                <p>
                  We may verify the authenticity of content you post and may
                  request supporting evidence; failure to provide it may result
                  in termination of membership without refund.
                </p>
              </div>
            </div>
            <p>
              By submitting, posting, uploading, or otherwise making any content
              available in the public areas of the Website, you grant Astro
              Logical Solutions, its affiliates, successors, and permitted
              licensees a worldwide, non-exclusive, royalty-free, fully paid,
              irrevocable, and perpetual licence to use, reproduce, copy,
              display, publish, adapt, modify, distribute, and create derivative
              works from such content for purposes connected with the Website
              and its Services.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>4. Products, Pricing & Description Accuracy</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              The Website, the materials and content contained in it, and the
              products and services provided in connection with it, are provided
              on an "AS IS" basis without warranties of any kind, either express
              or implied, except as expressly provided to the contrary in
              writing by the Company. The material on this Website is for
              general information only and should not be relied upon as the sole
              basis for any decision without consulting primary, more accurate,
              more complete or more timely sources. Any reliance on the material
              is at your own risk. We make every effort to display the colours,
              sizes and images of our products as accurately as possible;
              however, the actual colours you see depend on your device and
              monitor, and we cannot guarantee that your display will accurately
              reflect the product on delivery. Because our gemstones and
              rudraksha are natural, each piece has a distinctive colour,
              texture and origin, and may therefore differ slightly from the
              displayed image. Packaging may also vary from that shown. Slight
              natural variation of this kind is a feature of genuine natural
              products and is not a defect. Right to correct errors and refuse
              or cancel orders. Prices on our Website are subject to change
              without notice, and you will be charged the price listed on the
              day of purchase. We reserve the right (but are not obligated) to
              limit the sale of our products or services to any person,
              geographic region or jurisdiction, to limit quantities, and to
              discontinue any product at any time. We reserve the right to
              refuse, correct, cancel or refund any order — including after an
              order has been placed — where there is an obvious pricing or
              description error, suspected fraud, stock unavailability, or where
              delivery to the specified location cannot be fulfilled; in such
              cases you will be notified and any amount charged for the affected
              order will be refunded. Prices for orders shipped within India are
              payable in INR and are inclusive of CGST/SGST/IGST as applicable;
              a GST tax invoice is issued on every order.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>5. Order Acceptance, Cancellation & Modifications</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Your order is an offer to buy, which we may accept or decline as
              set out above. Certain products may be available exclusively
              online, may have limited quantities, and/or may be made to order
              or procured on order; these are subject to return or exchange only
              in accordance with our Refund Policy.
            </p>

            <div className="shipping-info-cards">
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>Cancellation before dispatch</h4>
                <p>
                  You may cancel an order before it is dispatched — please
                  message us on WhatsApp as soon as possible. See our Refund
                  Policy for how refunds are processed.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Customised / made-to-order items</h4>

                <p>
                  For customised or engraved items, once the design is approved
                  and making begins, the making charges are non-refundable, as
                  the piece is created specifically for you.
                </p>
              </div>

              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Changes to the Service</h4>

                <p>
                  We may modify or discontinue the Website or any product,
                  service, tool or content, temporarily or permanently, with or
                  without notice, and are not liable to you or any third party
                  for doing so.
                </p>
              </div>
            </div>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>6. Shipping, Delivery & Customs</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Please check whether we deliver to your PIN code at checkout; if
              no courier service is available in your area, we apologise for the
              inconvenience and request that you contact
              support@astrologicalsolutions.in Delivery to certain locations may
              not be possible due to country-specific restrictions or logistical
              issues, and we reserve the right to cancel or modify any order
              that cannot be fulfilled to the specified location, with a full
              refund of the affected order. <br />
              <br />A tentative delivery date is shared with your order
              confirmation, and the exact date is confirmed once your order is
              ready for dispatch. Delivery times are estimates only and are
              subject to change due to factors beyond our control — including
              shipment issues, customs delays, weather or other unforeseen
              circumstances — and we cannot be held responsible for delays
              caused by third parties or external factors, though we will keep
              you informed. For international orders, any customs duties or
              taxes levied by the destination country are payable by the buyer
              on delivery and are non-refundable. Full timelines, insurance,
              tracking and international terms are set out in our Shipping
              Policy and Customs & Duty page.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>
                7. Astrological & Spiritual Products — No Guaranteed Outcome
              </h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We ask you to take note of the nature of the products and services
              we offer, and to use your discretion when ordering them. The
              astrological remedies, consultations and predictions provided by
              Maneish RK Sharma are grounded in astrological and Vedic
              principles and are meant to offer guidance and self-reflection.
              Astrology is inherently interpretive, and results may vary for
              each individual. The advice given should complement, and not
              replace, professional counsel in areas such as medical, legal or
              financial matters. <br /> Maneish RK Sharma does not guarantee any
              specific outcome, and clients and users are encouraged to make
              their own informed decisions. Gemstones and rudraksha are offered
              as items of traditional faith and belief; they are not medicine
              and make no promise of a cure or a guaranteed result. We do not
              warrant that the quality of any product, service, information or
              material purchased or obtained by you will meet your expectations,
              or that any errors in the Service will be corrected. Please review
              all product and service related materials before proceeding.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>8. Disclaimer of Warranties</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              To the maximum extent permitted by applicable law, your use of the
              Website is at your sole risk. This Agreement strictly limits our
              liability and we do not provide warranties for the Service beyond
              those that cannot be excluded by law.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>9. Limitation of Liability</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              This is an important clause that limits the Company's liability to
              you. Please read it carefully.
            </p>
          </div>

          <div className="seller-grievance-box">
            <p>
              <b>Important</b> — You expressly understand and agree that the
              Company and its subsidiaries, affiliates, officers, employees,
              agents, partners and licensors shall not be liable to you for any
              direct, indirect, incidental, special, consequential or exemplary
              damages, including, but not limited to, damages for loss of
              profits, goodwill, use, data or other intangible losses (even if
              the Company has been advised of the possibility of such damages),
              resulting from: (i) the use of, or inability to use, the Service
              or Website; (ii) the cost of procurement of substitute goods and
              services resulting from any goods, data, information or services
              purchased or obtained, or messages received or transactions
              entered into, through or from the Website; (iii) unauthorised
              access to or alteration of your transmissions or data; (iv)
              statements or conduct of any third party on the Service; or (v)
              any other matter relating to the Website. Liability cap.
              Notwithstanding anything to the contrary contained herein, the
              Company's liability to you for any cause whatsoever, and
              regardless of the form of the action, will at all times be limited
              to the amount paid, if any, by you to the Company for the Service
              during the term of membership.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>10. Indemnification</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              You agree to indemnify and hold the Company, its subsidiaries,
              affiliates, officers, agents, and other partners and employees,
              harmless from any loss, liability, claim or demand, including
              reasonable attorney's fees, made by any third party due to or
              arising out of your use of the Service in violation of this
              Agreement, and/or arising from a breach of this Agreement, and/or
              any breach of your representations and warranties set forth above.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>11. Intellectual Property Rights</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              The Company owns and retains all proprietary rights in the Astro
              Logical Solutions Website and the products and services offered on
              it. The Website contains copyrighted material, trademarks, brand
              names, logos and other proprietary information of the Company and
              its licensors. Except for information that is in the public domain
              or for which you have been given express written permission, you
              may not copy, modify, publish, transmit, distribute, perform,
              display, reproduce or sell any such proprietary information. Any
              such act, or attempted act, constitutes a violation of this
              Agreement and may result in immediate termination of your
              membership without refund. <br /> The Astro Logical Solutions
              Website is for the personal use of individual members and may not
              be used for any commercial endeavour unless you are registered and
              approved as an "Affiliate" of Astro Logical Solutions . You agree
              not to reproduce, duplicate, copy, sell, resell or exploit any
              portion of the Service without our express written permission.
              Illegal or unauthorised uses of the Website — including
              unauthorised framing of, or linking to, the Website — will be
              investigated and appropriate legal action taken, including civil,
              criminal and injunctive remedies. Astro Logical Solutions shall be
              entitled to recover from you (and your successors, heirs and
              assigns) any profit, revenue or benefit that you have gained,
              received or expected to receive through unauthorised use of this
              Website, together with a penalty at 50% of such profit, revenue or
              benefit.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>12. Prohibited Uses</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              The Company reserves the right to investigate and terminate your
              membership if you misuse the Service or proprietary information,
              or behave in a manner that is inappropriate, unlawful or illegal.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>13. Third-Party Links, Advertisers & Content</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              Advice, opinions, statements, offers or other information or
              content made available through the Website but not directly by us
              are those of their respective authors, who are solely responsible
              for them, and should not necessarily be relied upon. The Company
              does not guarantee the accuracy, completeness or usefulness of any
              such information, and does not adopt, endorse or accept
              responsibility for the accuracy or reliability of any opinion,
              advice or statement made by any third party appearing on the
              Website. We recommend that you consult a certified professional
              for any such advice or information. Under no circumstances will
              the Company or its affiliates be responsible for any loss or
              damage resulting from your reliance on information or other
              content posted on, or transmitted through, the Website. <br /> Any
              correspondence or business dealings with, or participation in
              promotions of, advertisers or third parties found on or through
              the Service — including payment and delivery of related goods or
              services, and any related terms, warranties or representations —
              are solely between you and that advertiser or third party. You
              agree that the Company shall not be responsible or liable for any
              loss or damage of any kind incurred as a result of such dealings
              or the presence of such advertisers on the Website. While
              providing services, Astro Logical Solutions may outsource any part
              of them to a competent person or organisation, with or without
              disclosing this to you; however, your membership rights and
              responsibilities continue only against Astro Logical Solutions and
              not against such persons or organisations.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>14. Force Majeure</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              We are not liable for any delay in the performance, or for any
              non-performance, of any of our obligations, and shall not be
              liable for any loss or damage caused thereby, where the same is
              occasioned by any cause beyond our reasonable control — including,
              but not limited to, an act of God, war, civil disturbance, riots,
              strikes, lock-outs, governmental or parliamentary restrictions,
              prohibitions or enactments of any kind, pandemic, import or export
              regulations, exchange-control regulations, accident, or the
              non-availability of or delay in transport.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>15. Term & Termination</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              This Agreement remains in full force and effect while you use the
              Website and/or are a member. You may terminate your membership at
              any time by informing Astro Logical Solutions in writing or by ceasing to use
              the Website. If in our sole judgment you fail (or we reasonably
              suspect that you have failed) to comply with any term of these
              Terms of Service, we may terminate this Agreement at any time
              without notice; you will remain liable for all amounts due up to
              and including the date of termination, and we may deny you access
              to our Services. If your membership is terminated for a material
              breach, you will not be entitled to any refund of unused
              subscription fees. All decisions regarding termination are made at
              the sole discretion of Astro Logical Solutions, and any provision that by its
              nature is intended to survive termination — including obligations
              and liabilities incurred prior to termination — shall survive.
            </p>
          </div>

          <div className="content-section">
            <div className="section-heading">
              <h3>16. Communications Consent</h3>
              <div className="heading-line"></div>
            </div>
            <p>
              By registering your contact details with us, you authorise and
              give consent to the Company — either itself or through any
              third-party service provider — to send you, from time to time,
              information, alerts, SMS, other messages, calls and commercial
              communication and other service-related communications on the
              telephone number(s) you have provided, whether or not those
              numbers are registered with the National Do Not Call Registry or
              listed in the National Customer Preference Register. You confirm
              that you will not hold the Company or its third-party service
              provider liable, or institute a complaint under the Telecom
              Commercial Communications Customer Preference Regulations (TRAI),
              2010 or any other applicable regulations, in respect of such
              communications. If you wish to stop receiving such communications,
              please write to us at support@astrologicalsolutions.in.
            </p>
          </div>
          <div className="content-section">
            <div className="section-heading">
              <h3>17. General — Amendments, Severability & Entire Agreement</h3>
              <div className="heading-line"></div>
            </div>
            <div className="shipping-info-cards">
              <div className="shipping-info-card">
                <div className="card-top-line"></div>
                <h4>Right to amend</h4>
                <p>
                  These Terms may be changed by Astro Logical Solutions at any time,
                  effective upon posting on the Website. Your continued use of
                  the Website or Service after such posting constitutes
                  acceptance of the changes.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Severability</h4>

                <p>
                  If any provision of this Agreement is held invalid or
                  unenforceable, the remainder of the Agreement shall continue
                  in full force and effect.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Entire agreement</h4>

                <p>
                  This Agreement, together with the policies referenced in it,
                  contains the entire agreement between you and the Company
                  regarding your use of the Website and the Service.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>No third-party beneficiaries</h4>

                <p>
                  This Agreement is intended solely for the benefit of the
                  parties to it and confers no rights or benefits on any third
                  party.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Report misuse</h4>

                <p>
                  You are under an obligation to report any misuse or abuse of
                  the Website; on receiving a complaint we may investigate and,
                  if necessary, terminate the responsible member's membership.
                </p>
              </div>
              <div className="shipping-info-card">
                <div className="card-top-line"></div>

                <h4>Related policies</h4>

                <p>
                  These Terms incorporate our  <a href="/privacy-policy">Privacy Policy</a> ,
                  <a href="/refund-policy">Refund Policy</a> and
                  <a href="/shipping-policy">Shipping Policy</a>
                  by reference.
                </p>
              </div>
            </div>
          </div>
          <section className="delivery-section">
            <div className="delivery-content">
              <h2>Still Have a Question?</h2>
              <p>
                Our team is here Monday to Saturday, 10am–7pm IST. Message us on
                WhatsApp for the fastest <br />
                help with any return, refund or cancellation.
              </p>
               <div className="delivery-buttons">
                <a href="https://api.whatsapp.com/send/?phone=917351739191&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0" className="delivery-btn">
                  Chat on WhatsApp
                </a>
                <a href="https://api.whatsapp.com/send/?phone=917351739191&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0" className="delivery-btn">
                  Visit Help Center
                </a>
              </div>
            </div>
          </section>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Terms;
